import { render, staticRenderFns } from "./DashboardRatingWidget.vue?vue&type=template&id=3a024f00&scoped=true"
import script from "./DashboardRatingWidget.vue?vue&type=script&lang=js"
export * from "./DashboardRatingWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardRatingWidget.vue?vue&type=style&index=0&id=3a024f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a024f00",
  null
  
)

export default component.exports